import {ClassStylable} from "../../models/common/ComponentBehavioural";

export interface LogoProps extends ClassStylable {
    /**
     * small: 32px x 32 px
     * normal: 64px x 64px
     * large: 128px x 128px
     */
    size?: 'small' | 'normal' | 'large'
}

export function Logo( props: LogoProps ) {

    let size = 64;

    if( props.size === "small" ) {
        size = 32;
    }

    if( props.size === 'large' ) {
        size = 128;
    }
    
    
    return (
        <div className={ props.className } style={{ width: size, height: size }}>
            <svg width={ size } height={ size } viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M45.1568 11.4021C43.6696 8.39665 38.7635 7.67962 32.4468 9.05265C37.1383 8.45767 40.6339 9.28149 41.8145 11.6614C44.1449 16.3602 36.525 25.3765 24.781 31.7839C15.6433 36.7726 6.72028 38.7101 2.10545 37.1083C6.15301 40.2052 16.7012 38.4508 27.4947 32.562C39.7294 25.8799 47.6405 16.406 45.1568 11.4021Z"
                      fill="currentColor"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                />
                <path d="M27.5 17.5C27.5 18.6046 26.6046 19.5 25.5 19.5C24.3954 19.5 23.5 18.6046 23.5 17.5C23.5 16.3954 24.3954 15.5 25.5 15.5C26.6046 15.5 27.5 16.3954 27.5 17.5Z"
                      fill="currentColor"
                      stroke="currentColor"
                />
                <path d="M18.2753 16.5616C10.8241 20.7112 4.21618 26.9814 5.70335 29.88C7.19053 32.7787 15.071 31.6192 23.3041 27.2865C31.5372 22.9691 37.0106 17.1109 35.5081 14.2275C35.4621 14.1207 35.4008 14.0292 35.3241 13.9376C36.336 16.4854 31.4606 21.5046 24.2393 25.288C16.8648 29.163 9.85823 30.2767 8.57038 27.79C7.28252 25.3033 17.8 16.7905 18.26 16.5616"
                      fill="currentColor"
                />
                <path d="M18.2753 16.5616C10.8241 20.7112 4.21618 26.9814 5.70335 29.88C7.19053 32.7787 15.071 31.6192 23.3041 27.2865C31.5372 22.9691 37.0106 17.1109 35.5081 14.2275C35.4621 14.1207 35.4008 14.0292 35.3241 13.9376C36.336 16.4854 31.4606 21.5046 24.2393 25.288C16.8648 29.163 9.85823 30.2767 8.57038 27.79C7.28252 25.3033 17.8 16.7905 18.26 16.5616"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                />
            </svg>
        </div>


    );
    
}